export class BucketBrowserFile {
  name: string = '';
  isFolder: boolean = false;
  path: string = '';
  id: number = 0;

  constructor(name: string, isFolder: boolean, path: string, id: number) {
    this.name = name;
    this.isFolder = isFolder;
    this.path = path;
    this.id = id;
  }
}